import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    zenView: false
};

const appUiSlice = createSlice({
    name: 'appUi',
    initialState,
    reducers: {
        setZenView: (state, action) => {
            state.zenView = action.payload;
        },
        reset() {
            return initialState;
        }
    },
});

export const appUiAction = appUiSlice.actions;
export const appUiReducer = appUiSlice.reducer;
